<div class="flex flex-col gap-4 p-4">
  <h1 class="text-2xl leading-snug">Personenanzahl</h1>
  <div class="flex flex-col gap-4">
    <label for="person-count-select" class="font-medium">Für wie viele Personen möchten Sie reservieren?</label>
    <select id="person-count-select" 
            (change)="setPersonCount($event)" 
            class="p-4 bg-white rounded-lg border-[1px] border-benzGrey-900 focus:outline-none focus:ring-2 focus:ring-benzRed-700"
            aria-required="true">
      <option value="" disabled selected>Bitte Anzahl Personen wählen</option>
      @for (option of personCountOptions(); track $index) {
        <option value="{{ option }}">{{ option }} Personen</option>
      }
    </select>
    <p class="text-sm text-benzGrey-700">{{ progressService.selectedLodge()?.title_public }} kann Reservierungen in Vielfachen von
      @if (progressService.selectedLodge()!.table_factors.length > 1) {
        {{ progressService.selectedLodge()!.table_factors.slice(0, -1).join(", ") }} oder {{ progressService.selectedLodge()!.table_factors.slice(-1) }}
      } @else {
        {{ progressService.selectedLodge()!.table_factors.join(", ") }}
      }
      @if (progressService.selectedLodge()!.table_factors.length !== 1 || progressService.selectedLodge()!.table_factors[0] != 1) {
        Personen
      } @else {
        Person
      } entgegen nehmen.</p>
    @if (progressService.selectedPersons()) {
      <button type="button" routerLink="/booking/tokens" class="px-8 py-4 bg-benzRed-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-white" [attr.aria-label]="'Für ' + progressService.selectedPersons() + ' Personen reservieren und weiter zur Produktauswahl'">Für {{ progressService.selectedPersons() }}
        Personen reservieren
      </button>
    }
    @if (progressService.selectedPackage()?.description) {
      <p class="text-sm">{{ progressService.selectedPackage()?.description }}</p>
    }
  </div>
</div>
